import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import 'rxjs/add/observable/of';
//import { Subscription } from 'rxjs/Subscription';
import { FormControl, Validators } from '@angular/forms';
import { SharedService } from '../../../shared/services/share.services';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ManageUser } from '../../../models/centre/manage-user.model';
//import { Page } from '../../../models/list/page.model';
import { UserUrl } from '../../../shared/urls/user.url';
import { BaseUrl } from '../../../shared/urls/base.url';
import { EditUserPopupComponent } from './edit-user-popup.component';
import { ManageUserService } from './manage-user.service';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
@Component({
  selector: 'manage-user',
  templateUrl: './manage-user.component.html',
  providers: [ManageUserService]
})

export class ManageUserComponent extends TMBDataTableComponent implements OnInit {
  public dataRow = new Array<ManageUser>();
  public filterData = {
    userName: '',
    showAll: false
  };

  constructor(public utility: Utility,
    public manageUserService: ManageUserService,
    public dialogService: DialogService,
    public baseService: BaseService,
    public sharedService: SharedService) {
    super(sharedService);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
    this.page.pageNumber = pageInfo.offset;
    let param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      userName: this.filterData.userName,
      isShowAll: this.filterData.showAll
    };
    // this.baseService.getData(url, param).subscribe(
    this.manageUserService.getUserList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          // update page info
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          // update dataSource
          this.dataRow = data['list'];
        }
      }
    );
  }

  /**
   * Filter list by user name
   */
  onFilter() {
    this.setPage({ offset: 0 });
  }

  /**
   * Update user/permission information
   * @param string userId
   */
  onEditItem(id: string) {
    const data = {
      id: id
    };
    this.dialogService.openComponentDialog(EditUserPopupComponent, data).subscribe(result => {
      // if add user success then reload the list
      if (result) {
        this.reloadPage(this.page.pageNumber, this.dataRow);
        // dispatch change user info event to header component (fix bug SD10001680-268)
        if (id === localStorage.getItem(AppConstants.activeLink.userId)) {
          this.sharedService.announceUserInfoUpdate(result);
        }
      }
    });
  }

  /**
   * Allow to send reset password email to user
   * @param string userId
   */
  onResetPassword(row) {
    //  let resetPasswordUrl = UserUrl.RESET_PASSWORD;
    //  this.baseService.postData(resetPasswordUrl + `/${id}`, null).subscribe(
    if (row) {
      this.manageUserService.resetPassword(row.id).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.dialogService.openSuccessDialog({ message: data.message });
          }
        }
      );
    }
  }

  resendActiveLink(row) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.user.resendActiveLinkUser }).subscribe(result => {
      if (result) {
        this.manageUserService.resendActiveLink(row.id, BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL).subscribe(
          (result) => {
            if (result) {
              const data = result.json();
              this.dialogService.openSuccessDialog({ message: data.message });
            }
          }
        );
      }
    });
  }
  
  /**
   * Remove user from the centre
   * @param string userId
   */
  onRemoveItem(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.user.removeUser }).subscribe(result => {
      if (result) {
        //  let url = UserUrl.REMOVE_CENTRE_USER.replace('{userId}', id);
        //  this.baseService.delete(url).subscribe(
        this.manageUserService.removeUser(id).subscribe(
          (result) => {
            if (result) {
              this.reloadPage(this.page.pageNumber, this.dataRow, true);
              const data = result.json();
              this.dialogService.openSuccessDialog({ message: data.message });
            }
          }
        );
      }
    });
  }

  /**
   * Update user status
   * @param string userStatus
   * @param string userId
   */
  onStatusChange(userData: any, event) {
    const checkedStatus = event.checked;
    const confirmMessage = (checkedStatus) ? AppMessages.user.disableUser : AppMessages.user.enableUser;
    this.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
      if (result) {
        const param = {
          id: userData.id,
          status: checkedStatus.toString()
        };
        // let url = UserUrl.CHANGE_USER_STATUS.replace('{id}', userData.id).replace('{status}', checkedStatus.toString());
        // this.baseService.postData(url, null).subscribe(
        this.manageUserService.changeUserStatus(param).subscribe(
          (res) => {
            if (res) {
              // just need to reload when showALl checkbox is uncheck
              if (!this.filterData.showAll) {
                this.setPage({ offset: 0 });
              }
            }
          },
          error => {
            userData.isDisabled = !checkedStatus;
          }
        );
      } else {
        userData.isDisabled = !checkedStatus;
      }
    });
  }

  /**
   * Filter list by all status
   */
  onShowAllChange(event) {
    this.setPage({ offset: 0 });
  }
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-user/manage-user.component.ts